import { render, staticRenderFns } from "./Payroll.vue?vue&type=template&id=381b6b6a&scoped=true"
import script from "./Payroll.vue?vue&type=script&lang=js"
export * from "./Payroll.vue?vue&type=script&lang=js"
import style0 from "./Payroll.vue?vue&type=style&index=0&id=381b6b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b6b6a",
  null
  
)

export default component.exports